import { Event3sType } from "@1js/m365-logger-types";
import { type LoggerContextProps } from "../context/LoggerContext";
import { getIsoTimeStringWithMs } from "../utils/getIsoTimeStringWithMs";
import { type LoggerProps } from "./type";

export const promptCardLogger = ({
  logger,
  logicalId,
  scenarioName,
  metaData,
}: LoggerContextProps) => {
  const sendPromptCardClickEvent = ({ prompt }: LoggerProps) => {
    logger.log3sEvent?.({
      localTime: getIsoTimeStringWithMs(new Date()),
      eventType: Event3sType.SearchEntityClicked,
      logicalId,
      scenario: scenarioName,
      id: prompt.ReferenceId ?? "null",
      metaData: JSON.stringify({
        referenceId: `${prompt.ReferenceId}`,
        ...metaData?.(Event3sType.SearchEntityClicked),
      }),
    });
  };

  const sendPromptCardFavoriteEvent = (
    { prompt }: LoggerProps,
    favorite: boolean
  ) => {
    logger.log3sEvent?.({
      localTime: getIsoTimeStringWithMs(new Date()),
      eventType: Event3sType.SearchEntityClicked,
      logicalId,
      id: prompt.ReferenceId ?? "null",
      scenario: scenarioName,
      metaData: JSON.stringify({
        referenceId: `${prompt.ReferenceId}`,
        eventId: favorite ? "Bookmarked" : "Unbookmarked",
      }),
    });
  };

  return {
    sendPromptCardClickEvent,
    sendPromptCardFavoriteEvent,
  };
};
